import React, { useEffect } from 'react'

import { GhostPost } from '../../../utils/types'
import styles from './IconsLoader.module.scss'

type Props = {
  post: GhostPost
}

const IconsLoader: React.FC<Props> = ({ post }) => {
  const handleUpdateIcons = () => {
    const elements = Array.from(document.querySelectorAll('.icon'))
    elements.forEach((el) => {
      if (el.innerHTML) {
        return
      }
      const iconClass = el.classList
        .toString()
        .split(' ')
        .find((cl) => cl !== 'icon')
      const icon = document.createElement('img')
      icon.className = styles.icon
      icon.setAttribute('data-icon', 'true')
      icon.src = `https://blog.chordchord.com/blog/content/images/icons/${iconClass}.svg`
      icon.alt = iconClass || ''
      el.appendChild(icon)
    })
  }
  useEffect(() => {
    handleUpdateIcons()
  }, [post])
  return null
}

export default IconsLoader
